import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
const WhatApp = () => {
  // Your WhatsApp number in international format (no +, no spaces)
  const phoneNumber = "9717055088";

  // WhatsApp URL to open chat
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed right-2 bottom-20 bg-green-500 z-10  hover:bg-green-600 text-white rounded-full p-3 shadow-lg flex items-center justify-center"
      aria-label="Chat on WhatsApp"
    >
      {/* WhatsApp SVG Icon */}
      <FontAwesomeIcon icon={faWhatsapp} className="h-6 w-6" />
    </a>
  );
};

export default WhatApp;

//  <section className="relative bg-[#2f68a2] overflow-hidden pb-10  text-white">
//         {/* Content */}
//         <div className="relative z-20 max-w-7xl mx-auto  px-6 py-0 grid md:grid-cols-2 lg:gap-20 md:gap-10  items-start">
//           {/* Left Side */}
//           <div className="mt-12">
//             <h1 className="text-3xl md:text-4xl font-bold leading-snug mb-4">
//               SEO Services
//             </h1>
//             <p className="text-white/90 mb-6 text-lg">
//               In today’s digital world, a website isn’t enough. Our expert SEO
//               services help you rank higher, attract targeted traffic, and boost
//               visibility—so customers find you first.
//             </p>
//             <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded shadow-md transition">
//               Let’s Get Started Today!
//             </button>
//           </div>

//           {/* Right Side Image */}
//           <div className="flex justify-center">
//             <img
//               src={SEOO}
//               alt="SEO Illustration"
//               className="md:w-[80%] object-cover w-3/5 max-w-lg animate-float"
//             />
//           </div>
//         </div>

//         {/* FIRST CURVE - White */}
//         <div className="absolute bottom-0 left-0 w-full z-10">
//           <svg
//             className="w-full h-auto"
//             viewBox="0 0 1440 320"
//             preserveAspectRatio="none"
//           >
//             <path
//               fill="#ffffff"
//               fillOpacity="1"
//               d="M0,160L60,165.3C120,171,240,181,360,165.3C480,149,600,107,720,117.3C840,128,960,192,1080,208C1200,224,1320,192,1380,176L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
//             />
//           </svg>
//         </div>

//         {/* SECOND CURVE - Light Blue */}
//         <div className="absolute bottom-[20px] left-0 w-full z-0">
//           <svg
//             className="w-full h-auto"
//             viewBox="0 0 1440 320"
//             preserveAspectRatio="none"
//           >
//             <path
//               fill="#a6c7e2" // Light blue like in the image
//               fillOpacity="1"
//               d="M0,288L60,272C120,256,240,224,360,197.3C480,171,600,149,720,160C840,171,960,213,1080,208C1200,203,1320,149,1380,122.7L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
//             />
//           </svg>
//         </div>
//       </section>
